import React from "react";
import {MIXED_CATEGORIES_LABEL, UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants";
import {Chip, Stack, Tooltip} from "@mui/material";
import ChevronIcon from "~/icons/svg/ChevronIcon.svg?react";

import type {TaxonomyCategory} from "../../stores/TaxonomyCategoryProvider";
import {useStores} from "../../stores";
import {
    categoryChipArrowStyle,
    categoryChipMaxWidth,
    doCategoryChipEllipsis,
    getCategoryChipSx,
} from "./categoryChip.utils";
import {DEFAULT_CATEGORY_COL_WIDTH} from "../../stores/ProfileStore.tsx";

type Props = {
    category: string[] | false | 'UNCATEGORIZED' | 'MIXED_CATEGORIES' | TaxonomyCategory
    showCategoryId?: boolean,
    colWidth?: number,
}
export const CategorizationViewOnlyComponent: React.FC<Props> = ({category, showCategoryId, colWidth}) => {
    const {p} = useStores();

    const isArray = Array.isArray(category);
    if (category === false || (isArray && (category as string[]).every(c => c === UNCATEGORIZED_VALUE) || category === 'UNCATEGORIZED')) {
        return <>{UNCATEGORIZED_LABEL}</>;
    }
    if (category === 'MIXED_CATEGORIES') {
        return <>{MIXED_CATEGORIES_LABEL}</>;
    }

    let cats: string[];
    let customerCategoryId: string;
    if (isArray) {
        cats = (category as string[]);
        customerCategoryId = '';
    } else {
        const c: TaxonomyCategory = (category as TaxonomyCategory);
        cats = c.data.labels;
        customerCategoryId = c.data.category_id || '';
    }

    const columnWidth = colWidth ?? p.p.cat_col_width ?? DEFAULT_CATEGORY_COL_WIDTH;
    const chipMaxWidth = categoryChipMaxWidth(columnWidth, cats.length);

    return <>
        {showCategoryId && customerCategoryId && <>
            <span className="part-cat-component-category-id">{customerCategoryId}</span>
        </>}
        <Stack
            direction="row"
            flexWrap="wrap"
            alignItems="center"
            gap="4px"
        >
            {cats.map((c, i) => {
                const categoryLabel = c === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : c;
                const [truncatedLabel, cutoff] = doCategoryChipEllipsis(categoryLabel, chipMaxWidth);

                const chip = <Chip
                    variant="outlined"
                    size="small"
                    label={truncatedLabel}
                    sx={getCategoryChipSx(chipMaxWidth)}
                />;

                return <React.Fragment key={i}>
                    {cutoff
                        ? <Tooltip title={categoryLabel}>{chip}</Tooltip>
                        : chip}
                    {(i < cats.length - 1) && <ChevronIcon style={categoryChipArrowStyle}/>}
                </React.Fragment>;
            })}
        </Stack>
    </>
};
